import React, { useState, useEffect } from 'react';
import {
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  View,
  ActivityIndicator,
  Pressable,
} from 'react-native';
import CheckBox from 'expo-checkbox';
import { Picker } from '@react-native-picker/picker';

import { createAddress, updateAddress, getStreetsData, getPlantationsData, getPropertyNamesData } from '../../../api/AllAddress ';
import BasicModalContainer from '../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../common/components/basicmodal/ModalFooter';
import { msgStr } from '../../../common/constants/Message';
import { useAlertModal } from '../../../common/hooks';
import { commonModalStyle } from '../../../common/components/basicmodal';
import { getPmcList } from '../../../api/Settings';
import MapModal from './MapModal';

const AddLocationModal = ({ isModalVisible, details, setUpdateLocationsTrigger, closeModal }) => {
  const isUpdate = details ? true : false;

  const { showAlert } = useAlertModal();
  const [ValidMessage, setValidMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [streets, setStreetsData] = useState([]);
  const [plantations, setPlantationsData] = useState([]);
  const [propertyNames, setPropertyNames] = useState([]);
  const [pmcs, setPmcsData] = useState([]);

  const [formValues, setFormValues] = useState<any>({
    id: null,
    number: null,
    street: null,
    street_id: null,
    plantation: null,
    plantation_id: null,
    property_name: null,
    property_name_id: null,
    property_type: 0,
    voucher_potential: null,
    fif_potential: null,
    guests: null,
    bedrooms: null,
    rental_company: null,
    xploriefif: null,
    xplorievoucher: null,
    geolat: null,
    geolong: null,
  });

  const [isMapModalVisible, setIsMapModalVisible] = useState(false);

  useEffect(() => {
    getStreetsData((jsonRes) => {
      const sortedData = jsonRes
      .filter((item: any) => item.street != null)
      .sort((a: any, b: any) => a.street.localeCompare(b.street));
      
      setStreetsData(sortedData);
    })
    getPlantationsData((jsonRes) => {
      setPlantationsData(jsonRes);
    })
    getPropertyNamesData((jsonRes) => {
      const sortedData = jsonRes
      .filter((item: any) => item.property_name != null)
      .sort((a: any, b: any) => a.property_name.localeCompare(b.property_name));

      setPropertyNames(sortedData);
    })
    getPmcList((jsonRes) => {
      const sortedData = jsonRes
      .filter((item: any) => item.pmc?.trim() != '')
      .sort((a: any, b: any) => a.pmc?.trim().localeCompare(b.pmc?.trim()));
      
      setPmcsData(sortedData);
    });

  }, [])

  useEffect(() => {
    if (isModalVisible && details) {
      setFormValues({
        id: details.id,
        number: details.number,
        street: details.street,
        street_id: details.street_id,
        plantation: details.plantation,
        plantation_id: details.plantation_id,
        property_name: details.property_name,
        property_name_id: details.property_name_id,
        property_type: details?.property_type ?? 0,
        voucher_potential: details.voucher_potential,
        fif_potential: details.fif_potential,
        guests: details.guests,
        bedrooms: details.bedrooms,
        rental_company: details.rental_company,
        xploriefif: details.xploriefif,
        xplorievoucher: details.xplorievoucher,
        geolat: details.geolat,
        geolong: details.geolong,
      })
    } else {
      setFormValues({
        id: null,
        number: null,
        street: null,
        street_id: null,
        plantation: null,
        plantation_id: null,
        property_name: null,
        property_name_id: null,
        property_type: 0,
        voucher_potential: null,
        fif_potential: null,
        guests: null,
        bedrooms: null,
        rental_company: null,
        xploriefif: false,
        xplorievoucher: false,
        geolat: null,
        geolong: null,
      })
    }
  }, [isModalVisible]);

  const updateFormValues = (key, value) => {
    setFormValues(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const AddLocationButtonHandler = () => {
    // if (!LocationTxt.trim()) {
    //   setValidMessage(msgStr('emptyField'));
    //   return;
    // }

    setIsLoading(true);

    // const payload:any = {
    //   location: LocationTxt,
    //   description: DescriptionTxt,
    // };

    const handleResponse = (jsonRes, status) => {
      switch (status) {
        case 201:
          showAlert('success', jsonRes.message);
          setUpdateLocationsTrigger(true);
          closeModal();
          break;
        case 409:
          showAlert('error', "This address is already exist");
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          closeModal();
          break;
      }
      setIsLoading(false);
    };

    const hasGeoLocation = formValues.geolat !== null && formValues.geolat !== '' && formValues.geolong !== null && formValues.geolong !== '';

    const payload = {
      ...formValues,
      fif_potential: parseFloat(formValues.fif_potential),
      voucher_potential: parseFloat(formValues.voucher_potential),
      geolat: formValues.geolat === null || formValues.geolat === '' ? null : parseFloat(String(formValues.geolat).trim()),
      geolong: formValues.geolong === null || formValues.geolong === '' ? null : parseFloat(String(formValues.geolong).trim()),
      bulkUpdateGeoLocation: hasGeoLocation, // if geolocation is null, update will not be bulk
    };

    if (isUpdate) {
      // formValues.id = Location.id;
      updateAddress(payload, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    } else {
      createAddress(payload, (jsonRes, status) => {
        handleResponse(jsonRes, status);
      });
    }
  };

  const checkInput = () => {
    // if (!formValues.trim()) {
    //   setValidMessage(msgStr('emptyField'));
    // } else {
    //   setValidMessage('');
    // }
  };

  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={isModalVisible}
    >
      <BasicModalContainer>
        <ModalHeader label={isUpdate ? 'Update' : 'Add' + 'Address'} closeModal={closeModal} />
        <ModalBody>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ marginRight: 30 }}>
              <Text style={styles.label}>Number</Text>
              <TextInput
                style={styles.input}
                placeholder="Number"
                value={formValues.number || ''}
                onChangeText={val => updateFormValues('number', val)}
                placeholderTextColor="#ccc"
              />
              <Text style={styles.label}>Street</Text>
              <Picker
                style={styles.select}
                selectedValue={formValues.street_id || ''}
                onValueChange={(val, index) => {
                  updateFormValues('street_id', val ? val : null);
                  updateFormValues('street', streets[index - 1]?.street ?? null);
                  // Set property type to 1 (House)
                  updateFormValues('property_type', 0)

                  // Clear property name when street is selected
                  if (val) {
                    updateFormValues('property_name_id', null);
                    updateFormValues('property_name', null);

                      
                    // Auto-select plantation (area) based on street's plantation_id
                    const selectedStreet = streets.find(prop => prop.id == val);
                    if (selectedStreet && selectedStreet.plantation_id) {
                      updateFormValues('plantation_id', selectedStreet.plantation_id);
                      // Find and set the plantation name
                      const matchingPlantation = plantations.find(p => p.id === selectedStreet.plantation_id);
                      updateFormValues('plantation', matchingPlantation?.plantation ?? null);
                    }
                  }
                }}
              >
                <Picker.Item label={""} value={""} />;
                {streets.map(street => (<Picker.Item key={street.id} label={street.street} value={street.id} />))}
              </Picker>
              <Text style={styles.label}>Property Name</Text>
              <Picker
                style={styles.select}
                selectedValue={formValues.property_name_id || ''}
                onValueChange={(val, index) => {
                  updateFormValues('property_name_id', val ? val : null);
                  updateFormValues('property_name', propertyNames[index - 1]?.property_name ?? null);
                  // Set property type to 1 (Condo)
                  updateFormValues('property_type', 1)

                  // Clear street when property name is selected
                  if (val) {
                    updateFormValues('street_id', null);
                    updateFormValues('street', null);
                    
                    // Auto-select plantation (area) based on property name's plantation_id
                    const selectedProperty = propertyNames.find(prop => prop.id == val);
                    if (selectedProperty) {
                      const latNum = parseFloat(String(selectedProperty.lat).trim());
                      const lngNum = parseFloat(String(selectedProperty.lng).trim());

                      if (!isNaN(latNum) && !isNaN(lngNum)) {
                        if (selectedProperty.lat && selectedProperty.lng) {
                          updateFormValues('geolat', selectedProperty.lat.toString());
                          updateFormValues('geolong', selectedProperty.lng.toString());
                        }
                      }

                      if(selectedProperty.plantation_id){
                        updateFormValues('plantation_id', selectedProperty.plantation_id);
                        // Find and set the plantation name
                        const matchingPlantation = plantations.find(p => p.id === selectedProperty.plantation_id);
                        updateFormValues('plantation', matchingPlantation?.plantation ?? null);
                      }
                    }
                  }
                }}
              >
                <Picker.Item label={""} value={""} />;
                {propertyNames.map(item => (<Picker.Item key={item.id} label={item.property_name} value={item.id} />))}
              </Picker>
              <Text style={styles.label}>Area</Text>
              <Picker
                style={styles.select}
                selectedValue={formValues.plantation_id || ''}
                onValueChange={(val, index) => {
                  updateFormValues('plantation_id', val ? val : null);
                  updateFormValues('plantation', plantations[index - 1]?.plantation ?? null);
                }}
              >
                <Picker.Item label={""} value={""} />;
                {plantations.map(plantation => (<Picker.Item key={plantation.id} label={plantation.plantation} value={plantation.id} />))}
              </Picker>
              <Text style={styles.label}>Property Type</Text>
              {/* <Picker style={styles.select} selectedValue={formValues.property_type} onValueChange={(val) => updateFormValues('property_type', val)}>
                <Picker.Item label={"House"} value={0} />;
                <Picker.Item label={"Condo"} value={1} />;
              </Picker> */}
              <View style={[styles.input, { justifyContent: 'center' }]}>
                <Text>{formValues.property_type === 0 ? 'House' : 'Condo'}</Text>
              </View>
              <Text style={styles.label}>Voucher Potential</Text>
              <TextInput
                style={styles.input}
                placeholder="Voucher Potential"
                value={formValues.voucher_potential || ''}
                onChangeText={val => updateFormValues('voucher_potential', val)}
                placeholderTextColor="#ccc"
                editable={false}
              />
              <Text style={styles.label}>FIF Potential</Text>
              <TextInput
                style={styles.input}
                placeholder="FIF Potential"
                value={formValues.fif_potential || ''}
                onChangeText={val => updateFormValues('fif_potential', val)}
                placeholderTextColor="#ccc"
                editable={false}
              />
            </View>
            <View>
              <Text style={styles.label}>Guests</Text>
              <TextInput
                style={styles.input}
                placeholder="Guests"
                value={formValues.guests || ''}
                onChangeText={val => {
                  updateFormValues('guests', val);
                  if (val) {
                    const guestsNum = parseInt(val);
                    if (!isNaN(guestsNum)) {
                      // Only calculate if the respective checkbox is checked
                      if (formValues.xplorievoucher) {
                        updateFormValues('voucher_potential', (guestsNum * 60).toString());
                      } else {
                        updateFormValues('voucher_potential', '');
                      }
                      if (formValues.xploriefif) {
                        updateFormValues('fif_potential', (guestsNum * 55).toString());
                      } else {
                        updateFormValues('fif_potential', '');
                      }
                    }
                  }
                }}
                placeholderTextColor="#ccc"
                keyboardType="numeric"
              />
              <Text style={styles.label}>Bedrooms</Text>
              <TextInput
                style={styles.input}
                placeholder="Bedrooms"
                value={formValues.bedrooms || ''}
                onChangeText={val => updateFormValues('bedrooms', val)}
                placeholderTextColor="#ccc"
              />
              <Text style={styles.label}>Rental Company</Text>
              <Picker
                style={styles.select}
                selectedValue={formValues.rental_company || ''}
                onValueChange={(val) => {
                  updateFormValues('rental_company', val);
                  
                  // Find the selected PMC object
                  const selectedPmc = pmcs.find(pmc => pmc.pmc === val);
                  
                  // Set the appropriate checkmark based on the deal value
                  if (selectedPmc) {
                    if (selectedPmc.deal === 'FIF') {
                      updateFormValues('xploriefif', true);
                      updateFormValues('xplorievoucher', false);
                    } else if (selectedPmc.deal === 'VOUCHER') {
                      updateFormValues('xploriefif', false);
                      updateFormValues('xplorievoucher', true);
                    }
                  }
                }}
              >
                <Picker.Item label={""} value={""} />;
                {pmcs.map(pmc => (
                  <Picker.Item key={pmc.id} label={pmc.pmc} value={pmc.pmc} />
                ))}
              </Picker>
              <Text style={styles.label}>Geolat</Text>
              <TextInput
                style={styles.input}
                placeholder="Geolat"
                value={formValues.geolat || ''}
                onChangeText={val => updateFormValues('geolat', val)}
                placeholderTextColor="#ccc"
              />
              <Text style={styles.label}>Geolong</Text>
              <TextInput
                style={styles.input}
                placeholder="Geolong"
                value={formValues.geolong || ''}
                onChangeText={val => updateFormValues('geolong', val)}
                placeholderTextColor="#ccc"
              />

              <TouchableOpacity onPress={() => setIsMapModalVisible(true)}>
                <Text style={styles.addButton}>Select on Map</Text>
              </TouchableOpacity>

              <Pressable
                style={{ flexDirection: 'row', marginVertical: 10, alignItems: 'center' }}
                onPress={() => { 
                  const newValue = !formValues.xploriefif;
                  updateFormValues('xploriefif', newValue);
                  // Recalculate FIF if guests exist
                  if (newValue && formValues.guests) {
                    const guestsNum = parseInt(formValues.guests);
                    if (!isNaN(guestsNum)) {
                      updateFormValues('fif_potential', (guestsNum * 55).toString());
                    }
                  } else {
                    updateFormValues('fif_potential', '');
                  }
                }}
              >
                <CheckBox value={formValues.xploriefif} style={{ marginRight: 10 }} />
                <Text>{'Xploriefif'}</Text>
              </Pressable>
              <Pressable
                style={{ flexDirection: 'row', marginVertical: 10, alignItems: 'center' }}
                onPress={() => { 
                  const newValue = !formValues.xplorievoucher;
                  updateFormValues('xplorievoucher', newValue);
                  // Recalculate Voucher if guests exist
                  if (newValue && formValues.guests) {
                    const guestsNum = parseInt(formValues.guests);
                    if (!isNaN(guestsNum)) {
                      updateFormValues('voucher_potential', (guestsNum * 60).toString());
                    }
                  } else {
                    updateFormValues('voucher_potential', '');
                  }
                }}
              >
                <CheckBox value={formValues.xplorievoucher} style={{ marginRight: 10 }} />
                <Text>{'Xplorievoucher'}</Text>
              </Pressable>
            </View>
          </View>
        </ModalBody>
        <ModalFooter>
          <TouchableOpacity onPress={AddLocationButtonHandler}>
            <Text style={styles.addButton}>{isUpdate ? 'Update' : 'Add'}</Text>
          </TouchableOpacity>
        </ModalFooter>
      </BasicModalContainer>
      {isLoading && (
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
      
      <MapModal
        isVisible={isMapModalVisible}
        onClose={() => setIsMapModalVisible(false)}
        onLocationSelect={(location) => {
          updateFormValues('geolat', location.latitude.toString());
          updateFormValues('geolong', location.longitude.toString());
          setIsMapModalVisible(false);
        }}
        initialLatitude={formValues.geolat ? parseFloat(formValues.geolat) : null}
        initialLongitude={formValues.geolong ? parseFloat(formValues.geolong) : null}
      />
    </Modal>
  );
};

const styles = commonModalStyle;

export default AddLocationModal;
